import React from 'react';

import { getVideoEmbedUrl, isYouTubeId, parseVideoUrl } from '@helps/parseVideoUrl';

import styles from './style.module.scss';

const VideoEmbed = ({ value = '', className = '' }) => {
    const parsed =
        parseVideoUrl(value) ||
        (isYouTubeId(value) ? { type: 'youtube', id: value } : null);

    const embedUrl = getVideoEmbedUrl(parsed);

    if (!embedUrl) {
        return (
            <div className={`${styles.fallback} ${className}`}>
                Не удалось отобразить видео. Проверьте ссылку.
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <iframe
                className={`${styles.video} ${className}`}
                src={embedUrl}
                title="Видео"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export { VideoEmbed };
